module.exports = __webpack_public_path__ + "static/media/border-right.b89895bc.svg";